export default __webpack_public_path__ + "static/media/downArrow.386613b9.svg";